export const FormTypes = [
    {
        "label": "Textbox",
        "value": 1
    },
    {
        "label": "File",
        "value": 2
    },
    {
        "label": "Textarea",
        "value": 3
    },
    {
        "label": "CKEditor",
        "value": 4
    }
]

export const Langs = [
    {
        "label": "Türkçe",
        "value": 1
    },
    {
        "label": "İngilizce",
        "value": 2
    }
]

export const Roles = [
    {
        "label": "User",
        "value": 1
    },
    {
        "label": "Admin",
        "value": 2
    }
]
